import { Injectable } from '@angular/core';
import { EnumResponse } from '../../models/EnumResponse';
import { Subscription } from 'rxjs';
import { EnumCatalogNames } from '../../helpers/enums/EnumCatalogNames';
import { EnumsAPIService } from '../API/EnumsAPI.service';
@Injectable({
    providedIn: 'root'
  })


export class EnumsService{

  public enumCatalog: EnumResponse[] = [];

  subscription_setEnumCatalogs: Subscription;

  constructor(
    private enumService: EnumsAPIService){
  }

  setEnumCatalogs(){
    this.subscription_setEnumCatalogs = this.GetAll().subscribe(
      (data) => {
        this.enumCatalog = data.result;
        this.subscription_setEnumCatalogs.unsubscribe();
      }
    );
  }

  getEnum(enumName: string){
    return this.enumCatalog.filter(x => x.enumName == enumName);
  }

  GetGeofenceEnums() {
    //traer los enums de geocercas
    var GeofenceCategories = this.getEnum(EnumCatalogNames.GeofenceCategories);
    var GeofenceTypes = this.getEnum(EnumCatalogNames.GeofenceTypes);
    
    //asigna los enums si existen, si no, se hardcodea de emergencia
    if (GeofenceCategories.length == 0) {
      const defaultCategories: EnumResponse[] = [
        { id: 1, enumName: "GeofenceCategories", key: "1", value: "Geocercas de Monitoreo" }
      ];
      GeofenceCategories = defaultCategories;
    }

    if (GeofenceTypes.length == 0){
      const defaultTypes = [
        { id: 1, enumName: "GeofenceTypes", key: "1", value: "Zona Segura - Alerta en Salida" },
        { id: 1, enumName: "GeofenceTypes", key: "2", value: "Zona Segura - Alerta en Entrada" }
      ];
      GeofenceTypes = defaultTypes;
    }

    return {
      GeofenceCategories: GeofenceCategories,
      GeofenceTypes: GeofenceTypes
    };
  }

  GetAll(){
    return this.enumService.GetAll();
  }

  GetByEnumAPI(enumName: string){
    return this.enumService.GetByEnumAPI(enumName);
  }
}
